import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Config from "../Config";
import LoginScreen from "../Views/Auth/LoginScreen";

import { HeadOfficeNavigator, OfficeNavigator } from "./MainScreenNavigators";

function AppNavigator(props) {
  const Navigator =
    props.user?.role === "headOffice" ? HeadOfficeNavigator : OfficeNavigator;
  return (
    <Router basename={Config.relativePath}>
      <Routes>
        <Route path="/login" exact element={<LoginScreen />} />
        <Route path="*" element={<Navigator />} />
      </Routes>
    </Router>
  );
}

export default AppNavigator;
